import script from "./UIPlayerStandStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIPlayerStandStatus.vue?vue&type=script&lang=ts&setup=true"

import "./UIPlayerStandStatus.vue?vue&type=style&index=0&id=796b58a4&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796b58a4"]])

export default __exports__